import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import Banner from "../components/Banner"
import AboutMe from "../components/AboutMe"
import Slideview from "../components/SlideView"
import Address from "../components/Address"

export default function about() {
  return (
    <Layout>
      <SEO
        title="Criador de Sites e Aplicativos"
        lang="en"
        description="Desenvolvedor de Sites e Aplicativos.Front End.Mobile.Web Designer.Criador de Sites em Goiânia"
      />
      <Banner />
      <AboutMe />
      <Slideview />
      <Address />
    </Layout>
  )
}
